import { HStack } from "@chakra-ui/react";
import FooterLeft from "./FooterLeft/FooterLeft";
import FooterRight from "./FooterRight/FooterRight";

export default function Footer({
  showSunsetAngle,
  setShowSunsetAngle,
  showWar,
  setShowWar,
  showMap,
  setShowMap,
}) {
  return (
    <HStack
      w="100%"
      justifyContent="space-between"
      alignItems="end"
      px="30px"
      py="5px"
      spacing="24px" // spacing between the grid and right stack when wrapped
    >
      <FooterLeft
        showSunsetAngle={showSunsetAngle}
        setShowSunsetAngle={setShowSunsetAngle}
        showWar={showWar}
        setShowWar={setShowWar}
        showMap={showMap}
        setShowMap={setShowMap}
      />
      {/* Right side */}
      <FooterRight />
    </HStack>
  );
}
